import { NEWCLASS_BASE_URL } from '@/config';

import * as types from './mutation-types';

function quizResultExportPlugin(store) {
  store.subscribe((mutation, state) => {
    if (mutation.type === types.SET_PAGE_RESULT_FOR_NEW_CLASS) {
      const parentWindow = window.parent;

      const currentPageId = state.viewerNewClassPages.newClassCurrentPage.id;

      const completePage = state.viewerNewClassPages.newClassPagination.page;
      const totalPage = state.viewerNewClassPages.newClassPagination.totalPages;

      let message = {
        'learning:answer':
          state.viewerNewClassPages.newClassPagesResult[currentPageId],
        'learning:complete': false,
      };

      if (completePage >= totalPage) {
        message = { ...message, 'learning:complete': true };
      }
      parentWindow.postMessage(JSON.stringify(message), NEWCLASS_BASE_URL);
    }
  });
}

export default (store) => {
  quizResultExportPlugin(store);
};
